export default "__VITE_ASSET__c5d4632a__"